import { createThunkEffect } from "../../utilities/ActionUtility";
import * as StatisticsEffect from "./StatisticsEffect";

export const REQUEST_SUBSCRIBERS = "StatisticsAction.REQUEST_SUBSCRIBERS";
export const REQUEST_SUBSCRIBERS_FINISHED = "StatisticsAction.REQUEST_SUBSCRIBERS_FINISHED";

export function requestSubscribers(params) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_SUBSCRIBERS, StatisticsEffect.requestSubscribers, params);
    };
}

export const REQUEST_ONE_OFFS = "StatisticsAction.REQUEST_ONE_OFFS";
export const REQUEST_ONE_OFFS_FINISHED = "StatisticsAction.REQUEST_ONE_OFFS_FINISHED";

export function requestOneOffs(params) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ONE_OFFS, StatisticsEffect.requestOneOffss, params);
    };
}

export const REQUEST_SALES_BY_PRODUCT = "StatisticsAction.REQUEST_SALES_BY_PRODUCT";
export const REQUEST_SALES_BY_PRODUCT_FINISHED = "StatisticsAction.REQUEST_SALES_BY_PRODUCT_FINISHED";

export function requestSalesByProduct(params) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_SALES_BY_PRODUCT, StatisticsEffect.requestSalesByProduct, params);
    };
}

export const REQUEST_SALES_BY_USER = "StatisticsAction.REQUEST_SALES_BY_USER";
export const REQUEST_SALES_BY_USER_FINISHED = "StatisticsAction.REQUEST_SALES_BY_USER_FINISHED";

export function requestSalesByUser(params) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_SALES_BY_USER, StatisticsEffect.requestSalesByUser, params);
    };
}

export const REQUEST_REPORTS = "StatisticsAction.REQUEST_REPORTS";
export const REQUEST_REPORTS_FINISHED = "StatisticsAction.REQUEST_REPORTS_FINISHED";

export function requestSingleIsinReports(params) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_REPORTS, StatisticsEffect.requestSingleIsinReports, params);
    };
}